import api from '../../service/api';
import routes from "../../service/apiRoutes";

export const passwordForgot = (data) => api.post(routes.forgotPassword, data, {noauth: true});
export const linkConfirmation = (data) => api.post(routes.forgotPassword, data, {noauth: true});